import * as React from 'react'
import { Layout, Menu, Col, Row } from 'antd'

import container from '../wires/Bootstrapper'

import credem from '../content/Credem_Banca_CMYK.svg'

const { Header } = Layout

export class AppHeaderLogin extends React.Component<any, any> {

   

    render() {
        return (
            <Header>
                <Row justify="space-between" align="middle">
                    <Col lg={{ offset: 7, span: 11 }} sm={{ offset: 6, span: 12 }} xs={{ offset: 2, span: 20 }}><img src={credem} height="56px" alt="Credem banca logo" /></Col>
                    <Col></Col>
                    <Col></Col>
                </Row>
            </Header>
        )
    }
}